import type { SalesPipelineStage, LocationType } from '../../types';

export const CHURNED_PAGE_SIZE = 10;
export const REVENUE_TARGET_DRAWER_PAGE_SIZE = 10;

export const SALES_PIPELINE_STAGE_COLORS: Record<
  SalesPipelineStage,
  { fill: string; text: string; shortLabel: string }
> = {
  ENQUIRY: { fill: '#1d4ed8', text: '#ffffff', shortLabel: 'ENQUIRY' },
  OPPORTUNITY: { fill: '#0f766e', text: '#ffffff', shortLabel: 'OPPORTUNITY' },
  QUOTATION: { fill: '#f59e0b', text: '#ffffff', shortLabel: 'QUOTATION' },
  SALES_ORDER: { fill: '#8b5cf6', text: '#ffffff', shortLabel: 'SALES ORDER' },
  INVOICED: { fill: '#16a34a', text: '#ffffff', shortLabel: 'INVOICED' },
};

export const PIPELINE_STAGE_SEQUENCE: SalesPipelineStage[] = [
  'ENQUIRY',
  'OPPORTUNITY',
  'QUOTATION',
  'SALES_ORDER',
  'INVOICED',
];

export const PIPELINE_STAGE_COUNT_KEY: Record<
  SalesPipelineStage,
  'enquiry' | 'opportunity' | 'quotation' | 'sales_order' | 'invoice'
> = {
  ENQUIRY: 'enquiry',
  OPPORTUNITY: 'opportunity',
  QUOTATION: 'quotation',
  SALES_ORDER: 'sales_order',
  INVOICED: 'invoice',
};

export type PipelineStageValueKey =
  | 'opportunity_value'
  | 'quotation_value'
  | 'sales_order_value'
  | 'net_invoice_value';

export const PIPELINE_STAGE_VALUE_KEY: Record<
  SalesPipelineStage,
  PipelineStageValueKey | null
> = {
  ENQUIRY: null,
  OPPORTUNITY: 'opportunity_value',
  QUOTATION: 'quotation_value',
  SALES_ORDER: 'sales_order_value',
  INVOICED: 'net_invoice_value',
};

export const PIPELINE_STAGE_DATE_KEY: Record<
  SalesPipelineStage,
  'last_enquiry' | 'last_opportunity' | 'last_quotation' | 'last_sales_order' | 'last_invoice'
> = {
  ENQUIRY: 'last_enquiry',
  OPPORTUNITY: 'last_opportunity',
  QUOTATION: 'last_quotation',
  SALES_ORDER: 'last_sales_order',
  INVOICED: 'last_invoice',
};

export const ALL_LOCATION_TYPES: LocationType[] = ['all', 'client', 'warehouse', 'vendor', 'prospect'];

export const LOCATION_TYPE_ORDER: Exclude<LocationType, 'all'>[] = [
  'client',
  'warehouse',
  'vendor',
  'prospect',
];

export const LOCATION_TYPE_META: Record<
  Exclude<LocationType, 'all'>,
  { label: string; color: string }
> = {
  client: { label: 'Clients', color: '#4CAF50' },
  warehouse: { label: 'Warehouses', color: '#F44336' },
  vendor: { label: 'Vendors', color: '#FFC107' },
  prospect: { label: 'Prospects', color: '#2196F3' },
};
